import React from 'react';
import { useTranslation } from 'react-i18next';

import scss from './SectionWrapper.module.scss';
import { RotatingLines } from 'react-loader-spinner';

function SectionWrapper({ result, children, isLoading }) {
  const { t } = useTranslation('resonance');

  return (
    <div className={scss.wrapper}>
      <div className={scss.header}>
        <h3 className={scss.title}>{t('benchmarks')}</h3>
        <div className={scss.result}>
          <span>{t('result')}:</span>
          {isLoading ? <RotatingLines width='20' strokeWidth='5' strokeColor='#fff' /> : <span>{result || '-/-'}</span>}
        </div>
      </div>
      <div className={scss.content}>{children}</div>
    </div>
  );
}

export default SectionWrapper;
